import { Clock, Globe, Target, Info, MapPin } from 'lucide-react';
import { formatCampaignType } from 'utils/campaignUtils';
import { GoogleIcon, MetaIcon } from 'components';

const CampaignDetails = ({ campaignPreview }) => {
  const getPlatformIcon = (provider) => {
    const classNames = 'w-12 h-12';
    if (provider?.toLowerCase().includes('google')) {
      return <GoogleIcon className={classNames} />;
    } else if (provider?.toLowerCase().includes('meta') || provider?.toLowerCase().includes('facebook')) {
      return <MetaIcon className={classNames} />;
    }
    return <Globe className={classNames} />;
  };

  const getCampaignBudget = (campaignPreview) => {
    if (campaignPreview.budget_amount_micros) {
      return `${campaignPreview.budget_amount_micros / 1000000} / ${campaignPreview.budget_type === 'DAILY' ? 'día' : 'mes'}`;
    }
    return null;
  };

  const getCampaignStatus = (campaignPreview) => {
    if (campaignPreview.status.toLowerCase() === 'draft') {
      return 'Borrador';
    }
    return 'Publicada';
  };

  const getCampaignDuration = (campaignPreview) => {
    if (campaignPreview.start_date && campaignPreview.end_date) {
      const startDate = new Date(campaignPreview.start_date).toLocaleDateString();
      const endDate = new Date(campaignPreview.end_date).toLocaleDateString();
      const diffTime = Math.abs(new Date(campaignPreview.end_date) - new Date(campaignPreview.start_date));
      const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return `${startDate} al ${endDate} (${days} días)`;
    }
    return null;
  };

  return (
    
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-2 sm:p-4 mb-4 flex justify-between items-start">
      <div className="space-y-1 sm:space-y-2">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full ${campaignPreview.status === 'active' ? 'bg-green-500' : 'bg-blue-600'}`} />
          <span className="text-[10px] sm:text-xs font-medium text-gray-900">
            {getCampaignStatus(campaignPreview)}
          </span>
        </div>
        <h3 className="text-base sm:text-lg font-semibold text-gray-900 line-clamp-1">{campaignPreview.name}</h3>
        <div className="flex flex-wrap gap-2 sm:gap-3 text-xs sm:text-sm text-gray-500">
          {getCampaignBudget(campaignPreview) && (
            <span className="flex items-center gap-1">
              {campaignPreview.currency}&nbsp;
              {getCampaignBudget(campaignPreview)}
            </span>
          )}
          {campaignPreview.objective && (
            <span className="flex items-center gap-1">
              <Target className="w-3 h-3 sm:w-4 sm:h-4" />
              {campaignPreview.objective}
            </span>
          )}
          {getCampaignDuration(campaignPreview) && (
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3 sm:w-4 sm:h-4" />
              {getCampaignDuration(campaignPreview)}
            </span>
          )}
        </div>
        {campaignPreview?.campaign_type && (
          <div className="flex items-center gap-1 text-xs sm:text-sm text-gray-500">
            <Info className="w-3 h-3 sm:w-4 sm:h-4" /> Tipo de campaña: <span className="font-medium">{formatCampaignType(campaignPreview.campaign_type)}</span>
          </div>
        )}
        {campaignPreview?.targeting?.locations?.length > 0 && (
          <div className="flex items-center gap-1 text-xs sm:text-sm text-gray-500">
            <MapPin className="w-3 h-3 sm:w-4 sm:h-4" /> Países: <span className="font-medium">{campaignPreview.targeting.locations.join(', ')}</span>
          </div>
        )}
      </div>
      {campaignPreview.provider && (
        <div className="block lg:flex-shrink-0 lg:flex">
          {getPlatformIcon(campaignPreview.provider)}
        </div>
      )}
    </div>
  );
};

export default CampaignDetails;